import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncNoShowPage({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/noShowPage"));
  console.log("Loading", AsyncNoShowPage.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncNoShowPage;
